import { useState, useEffect, useCallback } from 'react';
import { createEngagementClient } from '../../../../src/services/client';
import { GET_FAVORITE_PROGRAM } from '../engagementGql/favoriteContent';
import { addErrorInDatadogRum } from '../utils/utilities';

type FavoriteProgramContent = {
  __typename: 'Program';
  alternateName: string;
  categories: string[];
  imageWide: string;
  name: string;
  tiers: string[];
};

type FavoriteProgramItem = {
  contentV2?: FavoriteProgramContent;
  contentId: string;
  contentType: string;
  createdAt?: string; // Made optional
};

const PROGRAM_CONTENT_TYPE = 'program';

const useCheckFavoriteProgram = (programName?: string) => {
  const [isProgramFavorited, setIsProgramFavorited] = useState(false);
  const [favoritePrograms, setFavoritePrograms] = useState<FavoriteProgramContent[]>([]);
  const [loading, setLoading] = useState(false);

  const handleGetFavoritePrograms = useCallback(async () => {
    try {
      setLoading(true);
      const result = await createEngagementClient.query({
        query: GET_FAVORITE_PROGRAM,
        variables: {
          contentType: PROGRAM_CONTENT_TYPE,
          pageSize: 50,
        },
      });

      const items: FavoriteProgramItem[] = result?.data?.favoriteContent?.items || [];

      const favoriteContentItems: FavoriteProgramContent[] = [...items]
        .sort((a, b) => {
          const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
          const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
          return dateB - dateA;
        })
        .map((item) => item.contentV2)
        .filter((content) => content != null);

      if (programName) {
        const programFavorited = favoriteContentItems.some((item) => item.name === programName);
        setIsProgramFavorited(programFavorited);
      }

      setFavoritePrograms(favoriteContentItems);
    } catch (error) {
      addErrorInDatadogRum(error);
    } finally {
      setLoading(false);
    }
  }, [programName]);

  useEffect(() => {
    handleGetFavoritePrograms();
  }, [handleGetFavoritePrograms]);
  return { favoritePrograms, isProgramFavorited, loading };
};

export default useCheckFavoriteProgram;
